import Header from "../global/header";
import Footer from "../global/footer";
import Breadcrumbs from "../breadcrumbs";
import Bookcharacters from "../bookcharacters";
import bookData from "../../data/characterpage.json";
import {useParams} from "react-router-dom";

const SingleBookCharacters = ({headerv3, footer}) => {
  const {menuv2} = footer;
  const {slug} = useParams();
  const book = bookData.blog.blogList.find((b) => b.slug === slug);

  return (
    <>
      <Header header={headerv3} />
      <Breadcrumbs isBg="yes" title={book.title} />
      <Bookcharacters book={book} />
      <Footer isBg="yes" menu={menuv2} />
    </>
  );
};

export default SingleBookCharacters;
